import React from 'react';
import PropTypes from 'prop-types';

import LabeledTextInput from 'components/consumer/LabeledTextInput';

const CityField = ({
  id = 'city',
  name = 'city',
  value,
  error,
  isTouched,
  handleBlur,
  handleChange,
  updateShipping,
  isRequired = true,
  ...props
}) => (
  <LabeledTextInput
    id={id}
    type="text"
    name={name}
    label="City *"
    onChange={handleChange}
    onBlur={evt => {
      handleBlur(evt);

      if (!error) {
        updateShipping?.();
      }
    }}
    value={value}
    data-xc="shipping-city-field"
    autoComplete="address-level2"
    errorMessage={isTouched && error ? error : null}
    required={isRequired ? '' : undefined}
    aria-required={isRequired ? '' : undefined}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

CityField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  updateShipping: PropTypes.func,
  value: PropTypes.string,
};

export default CityField;
